/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

/**
 * MyIssues page view (component).
 *
 */

import {Component, Vue} from 'vue-property-decorator';


@Component({
    name: 'v-issues',
})

export default class Issues extends Vue {


}
